var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$route.meta.bodyClass},[_c('transition',[_c('keep-alive',[_c('router-view',{key:_vm.$route.fullPath})],1)],1),_c('footerMain')],1)}
var staticRenderFns = []

export { render, staticRenderFns }